export const defaultDevicesState = {
  notInGroupTotalCount: 0,
  notInGroupFirstDevicesLoaded: false,

  preferredTotalCount: 0,
  preferredFirstDevicesLoaded: false,

  standardTotalCount: 0,
  standardFirstDevicesLoaded: false,

  unverifiedTotalCount: 0,
  unverifiedFirstDevicesLoaded: false,

  /** @type { import('../types/adapted-device').AdaptedDevice[]} */
  devices: [],

  /** @type { import('../types/adapted-device').AdaptedDevice[] } */
  selectedDevices: [],

  /** @type { string[] } */
  selectedDeviceIds: [],

  /** @type { string[] } */
  verifyDeviceIds: [],
};

export const defaultGroupsState = {
  groupActionInProgress: false,
  selectedGroup: {},
  searchedGroups: [],
  selectedManageGroup: {},
  inSelectedGroupTotalCount: 0,
  unverifiedInSelectedGroupTotalCount: 0,
  inSelectedGroupFirstDevicesLoaded: false,
};

export const defaultState = {
  ...defaultDevicesState,
  ...defaultGroupsState,
  // Loading groups in app.js because we need this information
  // on every page and some components like group selector in drawer
  // that is why don't put it in defaultGroupState because it using
  // for clean up state between naviations
  /** @type {import('../types/device-group').DeviceGroup[]} */
  groups: null,
  /** @type {import('../types/user').User} */
  user: {
    id: '',
    name: '',
    email: '',
    isAdmin: false,
    capabilities: [],
    plan: 'unknown',
    verified: false,
    companyId: '',
    dr: '',
  },
  theme: '',
  options: {},
  isPremium: false,
  isSmallScreen: false,
  smallScreenSelection: false,
  jwtToken: null,

  /** @type {import('../types/features').Features} */
  features: {},

  modalType: '',
  modalData: null,
  previousModalType: '',
  tableBusy: false,
  detailsSummaryHidden: false,
  searchBarValue: '',
  isSearching: false,
  standalone: false,
  usedPremiumDeviceChanges: 0,
  maxFavoriteCount: 0,

  drawerOpen: false,
  groupDrawerOpen: false,
  filterDrawerOpen: false,

  /** @type {import('../types/device-filter').DeviceFilterGroup[]} */
  deviceFilters: null,

  verifyDeviceDrawerMode: false,
  deviceIdsWithOngoingChanges: new Set(),
  isVerifyInProgress: false,
  isSelectedStepperOpen: false,
  groupIdsWithOngoingChanges: new Set(),

  latestCreatedGroup: {},
  navigationRoute: '',
  isZeroTrustSetupDone: false,
  loadingDevices: {},

  language: 'en-EN',

  /** @type {string[]} */
  deviceLabels: null,
};
